import { render, staticRenderFns } from "./SettingsUserSubstituteView.vue?vue&type=template&id=0aefcb6f&scoped=true&"
import script from "./SettingsUserSubstituteView.vue?vue&type=script&lang=js&"
export * from "./SettingsUserSubstituteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefcb6f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aefcb6f')) {
      api.createRecord('0aefcb6f', component.options)
    } else {
      api.reload('0aefcb6f', component.options)
    }
    module.hot.accept("./SettingsUserSubstituteView.vue?vue&type=template&id=0aefcb6f&scoped=true&", function () {
      api.rerender('0aefcb6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsUserSubstituteView.vue"
export default component.exports